// Popup for the "Verified customer" / "Verified customer · Rewarded review"
// badges on published reviews. Content is swapped per click from the
// trigger's own data attributes into a single shared <dialog>, which reuses
// the theme's own dialog-component (assets/dialog.js) so the popup gets the
// site's real modal chrome — radius, backdrop, open/close animation,
// outside-click and Esc handling — instead of a bespoke one. The second
// paragraph/divider/closing line only show for the rewarded variant, which
// is the only trigger that supplies a data-badge-paragraph2 value.
class BadgeInfoModal extends HTMLElement {
  connectedCallback() {
    this.dialogEl = document.getElementById('review-badge-info-dialog');
    if (!this.dialogEl) return;

    this.heading = this.dialogEl.querySelector('[data-badge-modal-heading]');
    this.paragraph1 = this.dialogEl.querySelector('[data-badge-modal-paragraph-1]');
    this.paragraph2 = this.dialogEl.querySelector('[data-badge-modal-paragraph-2]');
    this.divider = this.dialogEl.querySelector('[data-badge-modal-divider]');
    this.closing = this.dialogEl.querySelector('[data-badge-modal-closing]');
    this.closeButton = this.dialogEl.querySelector('[data-badge-modal-close]');

    this.querySelectorAll('[data-badge-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => this.open(trigger));
    });

    this.closeButton?.addEventListener('click', () => this.dialogEl.closeDialog?.());
  }

  open(trigger) {
    // The trigger's markup uses data-badge-paragraph1/2 (no hyphen before
    // the digit) — dataset camelCasing only rewrites hyphen+letter, so a
    // "paragraph-1" attribute would silently read back as undefined here.
    const { badgeHeading, badgeParagraph1, badgeParagraph2, badgeClosing } = trigger.dataset;
    const hasSecondPart = Boolean(badgeParagraph2);

    if (this.heading) this.heading.textContent = badgeHeading || '';
    if (this.paragraph1) this.paragraph1.textContent = badgeParagraph1 || '';

    if (this.paragraph2) {
      this.paragraph2.textContent = badgeParagraph2 || '';
      this.paragraph2.hidden = !hasSecondPart;
    }
    if (this.divider) this.divider.hidden = !hasSecondPart;
    if (this.closing) {
      this.closing.textContent = badgeClosing || '';
      this.closing.hidden = !hasSecondPart;
    }

    this.dialogEl.showDialog?.();
  }
}

if (!customElements.get('badge-info-modal')) {
  customElements.define('badge-info-modal', BadgeInfoModal);
}
